import * as React from 'react';
import PropTypes from "prop-types";
import { Stack, Button } from '@mui/material';
import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
    root: {
        borderRadius: theme.spacing(3),
        fontSize: '1em',
        '&:hover ': {
            backgroundColor: theme.palette.primary.main,
            color: `${theme.palette.common.black} !important`,
        },
    },
}));
export default function CustomButton(props) {
    const { variant, color, children, size, fullWidth, onClick, style, disabled } = props;
    const classes = useStyles();
    return (
        <Button variant={variant}
            color={color}
            size={size}
            fullWidth={fullWidth}
            className={classNames([classes.root])}
            onClick={onClick}
            style={style}
            disabled={disabled}
        >
            {children}
        </Button>
    );
}

CustomButton.propTypes = {
    size: PropTypes.oneOfType([PropTypes.oneOf(['small', 'medium', 'large']), PropTypes.string]),
    variant: PropTypes.oneOfType([PropTypes.oneOf(['text', 'contained', 'outlined']), PropTypes.string]),
    color: PropTypes.oneOfType([PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']), PropTypes.string]),
    marginBottom: PropTypes.number,
    marginLeft: PropTypes.number,
    marginTop: PropTypes.number,
    marginRight: PropTypes.number,
    fullWidth: PropTypes.bool,
    onClick: PropTypes.func,
};